import { render, staticRenderFns } from "./CottonFileUpload.vue?vue&type=template&id=ef90217a&scoped=true&"
import script from "./CottonFileUpload.vue?vue&type=script&lang=js&"
export * from "./CottonFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./CottonFileUpload.vue?vue&type=style&index=0&id=ef90217a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef90217a",
  null
  
)

export default component.exports